export default {
    api: {
        //服务器地址
        domain: 'https://invite-api.szgqh.top/',
        //api地址
        base_url: 'https://invite-api.szgqh.top/admin/rpc',

        //请求超时时间（单位S）
        timeout: 1000,
    },

    page: {
        //每页显示条数
        page_size: 30
    },

    //文件服务器地址
    upload_url: 'https://invite-api.szgqh.top/admin/rpc',
    //文件服务器地址
    file_srv: 'https://invite-api.szgqh.top/'
}



// export default {
//     api: {
//         //服务器地址
//         domain: 'http://118.31.51.131:9988/',
//         //api地址
//         base_url: 'http://118.31.51.131:9988/admin/rpc',

//         //请求超时时间（单位S）
//         timeout: 60,
//     },
//     page: {
//         //每页显示条数
//         page_size: 20
//     },

//     //文件服务器地址
//     upload_url: 'http://118.31.51.131:9988/admin/rpc',
//     //文件服务器地址
//     file_srv: 'http://118.31.51.131:9988/'
// }

